import { gql } from "@apollo/client";

export const RESEND_FAX = gql`
  mutation resendFaxDocument($clientId: Int!, $requestId: String!) {
    resendFaxDocument(clientId: $clientId, requestId: $requestId) {
      id
    }
  }
`;
